// Shared UI style constants for small icon-only buttons used across the app.

export const ICON_SIZE = 18;
export const MOBILE_ICON_SIZE = 16;

// Matches existing inline styles used across multiple components.
export const commonIconButtonStyle = {
    border: 'none',
    padding: '4px 8px',
    height: '32px',
    minWidth: '32px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
};













